import type { NavMainProps } from '../types';

import { Nav, NavUl } from '../components';
import { NavList } from './nav-desktop-list';

export function NavDesktop({ data, className, ...other }: NavMainProps) {
  return (
    <Nav className={`shadow-nav bg-white p-[4px] rounded-md ${className}`} {...other}>
      <NavUl className="flex flex-row items-center h-full gap-2">
        {data.map((list, index) => (
          <NavList key={index} data={list} />
        ))}
      </NavUl>
    </Nav>
  );
}
